/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-28 12:07:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 16:48:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/Header/index.tsx
 */
import NoPermission from '@/src/components/NoPermission';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'src/components/Antd';
import _Header from 'src/components/Layouts/Header';
import {
  // isEditing,
  // onAddNewCategory,
  getSearch,
  onDataUpdate,
  onSearchChange,
  onSearchTagClose,
  postProductsSearch,
} from '../slice';

import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import GeneralModal from 'src/pages/SalesChannelCategory/Components/EditModal/General';
import {
  getOptions,
  submitChange,
} from 'src/pages/SalesChannelCategory/ProductCategory/EditModal/tools';
import { i18nGet } from 'src/tools/tools';
import Search from '../../Components/Search';

const Header = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const { modalOp, uuid: salesChannelUuid, userPermissions } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;

  const handleOnDataUpdate = (data: any) => {
    _d(onDataUpdate({ data }));
    onModalCancel();
  };

  const handleOnSearch = (search = []) => {
    const text = search.map((i) => i.value);

    _d(
      postProductsSearch({
        body: {
          salesChannelUuid,
          searchText: text,
        },
      }),
    );
  };

  //====request
  const optionsId = `newPostGetOptions${salesChannelUuid}`;
  const submissionId = `newPostCategoryProduct${salesChannelUuid}`;
  const requestId = [optionsId, submissionId];
  const _getOptions = ({ setOptions }) => {
    return getOptions({
      salesChannelUuid,
      selfUuid: null,
      requestId: optionsId,
      setOptions,
    });
  };
  const _submitChange = ({ urlSlug, parentUuid, name }) => {
    return submitChange({
      salesChannelUuid,
      selfUuid: null,
      requestId: submissionId,
      urlSlug,
      parentUuid,
      name,
      onOk: handleOnDataUpdate,
    });
  };
  //===request

  const onAddNew = () => {
    setModalTitle(
      getI18n('salesChannelCategoryProducts.index.createNewCategory'),
    );
    setModalContent(
      <GeneralModal
        onGetOptions={_getOptions}
        onSubmit={_submitChange}
        requestId={requestId}
        onOk={handleOnDataUpdate}
        salesChannelUuid={salesChannelUuid}
        onCancel={onModalCancel}
        slugCheckingUrl={'portal/salesChannel/category/products/checkUrlSlug'}
      />,
    );
    setShowModal(true);
  };

  return (
    <Element>
      <_Header
        left={getI18n('salesChannelCategoryProducts.index.productCategory')}
        right={
          userPermissions.canCreate && (
            <Button type='primary' onClick={onAddNew}>
              {getI18n('salesChannelCategoryProducts.index.createNewCategory')}
            </Button>
          )
        }
      />
      {userPermissions.canView ? (
        <Search
          onSearchTagClose={onSearchTagClose}
          onSearchChange={onSearchChange}
          getSearch={getSearch}
          //handleOnSearch={handleOnSearch}
          onSearchHasChange={handleOnSearch}
        />
      ) : (
        <NoPermission />
      )}
    </Element>
  );
};
export default ModalHoc(Header);
